
// util method to the get message element of an input element, auto create if haven't exist yet
function _getMessageElement(inputElement) {
  const inputParentElement = inputElement.closest('dd')
  let messageElement = inputParentElement.querySelector('.js-message')

  if (messageElement == null) {
    messageElement = document.createElement("p");
    messageElement.classList.add('js-message')

    inputParentElement.appendChild(messageElement)
  }

  return messageElement
}

// util method to remove the message element of an input element if exist
function removeMessageElement(inputElement) {
  const inputParentElement = inputElement.closest('dd')
  const messageElement = inputParentElement.querySelector('.js-message')

  if (messageElement != null) {
    messageElement.remove()
  }
}

// util method to show message text on an input element
function showMessage(inputElement, message) {
  const messageElement = _getMessageElement(inputElement)

  messageElement.classList.remove('error-text')
  messageElement.classList.add('supplement-text')
  messageElement.innerText = message
}

// util method to show error text on an input element
function showError(inputElement, error) {
  const messageElement = _getMessageElement(inputElement)

  messageElement.classList.add('error-text')
  messageElement.classList.remove('supplement-text')
  messageElement.innerText = error
}

export default {removeMessageElement, showError, showMessage}
